import type { SVGProps } from 'react';
const SvgEditWithoutLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="m6.237 15.167-.512 2.581a.45.45 0 0 0 .527.527l2.582-.512a.45.45 0 0 0 .23-.123l6.662-6.662.007-.007.338-.338-2.703-2.703-7.008 7.007a.45.45 0 0 0-.123.23m11.827-7.592-.8-.801-.019-.018-.82-.82a.75.75 0 0 0-.532-.22.75.75 0 0 0-.532.22l-1.318 1.319 2.703 2.703 1.318-1.318a.754.754 0 0 0 0-1.065"
    />
  </svg>
);
export default SvgEditWithoutLine;
